import { ajaxAuth } from '../gateway'
import { setAggs } from '@/store/aggs'

/**
 * notification search (the most used query in this app!)
 * @param {*} filters the filters to search with
 * @returns a promise to search results
 */
export function search (filters) {
  return ajaxAuth
    .post('/notifications/search', filters)
    .then(r => {
      // update vuex aggs activity store
      if (Object.keys(r.aggs).length > 0) {
        setAggs(r.aggs)
      }
      // pass-thru
      return r
    })
}
